var _circle, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8MicronesiaCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#64b5f6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "25.219,14.249 27.17,12.785 24.731,12.785 23.999,10.468 23.267,12.785 20.828,12.785 22.779,14.249 22.048,16.566 23.999,15.163 25.95,16.566"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "15.172,23.935 16.561,21.93 14.247,22.7 12.821,20.733 12.858,23.162 10.544,23.932 12.857,24.705 12.894,27.135 14.303,25.188 16.597,25.903"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "32.828,23.935 31.439,21.93 33.753,22.7 35.179,20.733 35.142,23.162 37.456,23.932 35.143,24.705 35.106,27.135 33.697,25.188 31.403,25.903"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "25.219,33.751 27.17,35.215 24.731,35.215 23.999,37.532 23.267,35.215 20.828,35.215 22.779,33.751 22.048,31.434 23.999,32.837 25.95,31.434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8MicronesiaCircular);
export default __webpack_public_path__ + "static/media/icons8-micronesia-circular.dacb331faea4ca9511dd7bef30837ccf.svg";
export { ForwardRef as ReactComponent };